import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(AuthService)
        .check()
        .pipe(
            switchMap((authenticated) => {
                // If the user is not authenticated...
                if (!authenticated) {
                    // Redirect to the sign-in page with a redirectUrl param
                    // (encoded, so that the query of the page does not become part of the sign-in address)
                    const urlTree = router.createUrlTree(['/sign-in'], {
                        queryParams:
                            state.url === '/sign-out'
                                ? {}
                                : { redirectURL: state.url },
                    });

                    return of(urlTree);
                }

                // Allow the access
                return of(true);
            })
        );
};
